
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landings/location",
      function () {
        return require("private-next-pages/landings/location.js");
      }
    ]);
  